import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// withCredentials makes browser send httpOnly auth cookies with every request.
// No tokens are stored in localStorage anymore (XSS-safe).
const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  withCredentials: true,
});

// CSRF defense: attach a custom header on all requests. Cross-origin attackers
// cannot set custom headers without a CORS preflight, which our fail-closed
// origin allowlist rejects → protects state-changing endpoints (especially
// multipart ones which don't otherwise trigger preflight).
api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers["X-Requested-With"] = "fuelexpress-admin";
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Normalise Pydantic v2 validation errors — FastAPI returns 422 with
    // `detail = [{type, loc, msg, input, url}, …]`. Rendering that array in
    // toast / JSX causes React "Objects are not valid as a child" crashes.
    // Flatten to a human-readable string so callers can `toast.error(err.response.data.detail)`
    // uniformly no matter what shape the server returned.
    const d = err.response?.data;
    if (d && Array.isArray(d.detail)) {
      d.detail = d.detail
        .map((e) => {
          const path = Array.isArray(e.loc) ? e.loc.filter((p) => p !== "body").join(".") : "";
          return path ? `${path}: ${e.msg}` : e.msg || String(e);
        })
        .join(" · ");
    } else if (d && d.detail && typeof d.detail === "object") {
      try { d.detail = d.detail.msg || JSON.stringify(d.detail); } catch { d.detail = "Request failed"; }
    }

    if (err.response?.status === 401 && !err.config.url?.includes("/auth/")) {
      // Cookie invalid/expired — client-side clean up + redirect
      try { sessionStorage.removeItem("ddd_user"); } catch { /* noop */ }
      // Route users to the login screen their session came from — staff/driver
      // are inside /app/* or /driver/*, everyone else goes to the public /login.
      const p = window.location.pathname;
      const staffContext = p.startsWith("/app") || p.startsWith("/driver") || p.startsWith("/ops-console");
      const target = staffContext ? "/ops-console-fx-9k2m4" : "/login";
      if (p !== target) window.location.href = target;
    }
    return Promise.reject(err);
  }
);

export default api;
